import latinize from 'latinize';
import pathUtils from 'path';

//
// Returns the basename of the given path.
//
//  path* (string) - The path to a file.
//  ext (string) - Optional extension to omit from the basename.
//
// Returns a string.
//
export function basename(path, ext) {
  return pathUtils.basename(path, ext);
}

//
// Same as path.dirname(), but returns instead of '' for the current directory.
//
export function dirname(path) {
  return pathUtils.dirname(path).replace(/^\.$/, '');
}

//
// Returns the file extension of the given path.
//
//  path* (string) - The path to a file.
//
// Returns a string.
//
export function extname(path) {
  return pathUtils.extname(path);
}

//
// Joins multiple paths together. Unlike the native path.join(), this method will always use forward
// slashes. It will also ensures the resulting path does or does not have a preceding slash
// depending on the first argument.
//
// Returns a string.
//
export function join() {
  const startsWithSlash = arguments[0].charAt(0) === '/';
  let joined = pathUtils.join(...arguments)
    .replace(/\\/g, '/') // convert backslashes to forward slashes
    .replace(/^\.$/, ''); // convert '.' to ''

  if (!startsWithSlash) {
    joined = joined.replace(/^\/+/, '');
  }

  return joined;
}

//
// Removes the part of basePath within path, resulting in a path relative to basePath.
//
//  path* (string) - The target path.
//  basePath* (string) - The base path.
//
// Returns a string.
//
export function removeBasePath(path, basePath) {
  path = path.replace(/^\//g, '');
  basePath = basePath.replace(/^\//g, '');

  if (path.substring(0, basePath.length) === basePath) {
    path = path.substring(basePath.length);
  }

  return path.replace(/^\//g, '');
}

//
// Replaces the filename in path, leaving the path and extension intact.
//
//  path* (string) - A file path.
//  newFilename* (string) - The new name of the file.
//
// Returns a string.
//
export function replaceFilename(path, newFilename) {
  const dir = dirname(path);
  const ext = pathUtils.extname(path);
  return pathUtils.join(dir, newFilename + ext);
}

//
// Generates a safe filename from an arbitrary string.
//
//  filename* (string) - A filename.
//
// Returns a string.
//
export function safeFilename(filename) {
  return latinize(filename)
    .trim()
    .replace(/\s+/g, '-') // convert whitespace to dashes
    .replace(/[^a-z0-9-_.]/gi, '') // only allow alphanum, dashes, underscores, and dots
    .replace(/--+/g, '-') // remove consecutive slashes
    .toLowerCase();
}
